import React from "react"

function TermsAndConditions() {
    return (
        <div className="prose max-w-2xl mx-auto py-8 px-8 sm:px-0">
            <h1 className="mb-4">TERMS AND CONDITIONS / POGOJI POSLOVANJA</h1>
            <h2>1. GENERAL PROVISIONS / SPLOŠNE DOLOČBE</h2>
            <p className="mb-6">
                These Terms and Conditions govern the relationship between the online store eduardbelsky.com (the “Seller”) and any person or entity making a purchase on the site (the “Buyer”).<br />
                By placing an order, the Buyer agrees to these Terms and the Privacy Policy and consents to the processing of their personal data in accordance with GDPR.<br />
                Ti pogoji poslovanja urejajo razmerje med spletno trgovino eduardbelsky.com (»Prodajalec«) in vsako osebo ali subjektom, ki opravi nakup na spletnem mestu (»Kupec«).<br />
                Z oddajo naročila Kupec potrjuje, da se strinja s temi Pogoji in Politiko zasebnosti ter soglaša z obdelavo svojih osebnih podatkov v skladu z GDPR.
            </p>
            <h2>2. PRODUCTS AND PRICES / IZDELKI IN CENE</h2>
            <p className="mb-6">
                All products on the website are original works of art. Prices are in euros and include applicable taxes. Shipping costs are calculated separately.<br />
                Vsi izdelki na spletni strani so originalna umetniška dela. Cene so v evrih in vključujejo davke. Stroški dostave se obračunajo posebej.
            </p>
            <h2>3. ORDER PROCESSING / OBDELAVA NAROČILA</h2>
            <p className="mb-6">
                To place an order, the Buyer must provide accurate personal data including name, address, email, and phone number.<br />
                Za oddajo naročila mora Kupec navesti točne osebne podatke, vključno z imenom, naslovom, e-pošto in telefonsko številko.
            </p>
            <h2>4. PAYMENT / PLAČILO</h2>
            <p className="mb-6">
                Payment can be made by bank transfer, credit card via secure gateway, or other methods listed on eduardbelskiy.com.<br />
                Plačilo je mogoče z bančnim nakazilom, kreditno kartico prek varnega prehoda ali drugimi metodami, navedenimi na eduardbelskiy.com.
            </p>
            <h2>5. SHIPPING / DOSTAVA</h2>
            <p className="mb-6">
                Shipping is made to the address provided. Delivery times and costs vary. The Seller is not responsible for delays caused by third parties.<br />
                Dostava se opravi na navedeni naslov. Časi in stroški dostave se razlikujejo. Prodajalec ne odgovarja za zamude, ki jih povzročijo tretje osebe.
            </p>
            <h2>6. RETURNS / VRAČILA</h2>
            <p className="mb-6">
                The Buyer has the right to withdraw within 14 days. Return costs are borne by the Buyer, except for defective or incorrect items.<br />
                Kupec ima pravico do odstopa v 14 dneh. Stroške vračila krije Kupec, razen v primeru poškodovanih ali napačnih izdelkov.
            </p>
            <h2>7. COPYRIGHT / AVTORSKE PRAVICE</h2>
            <p className="mb-6">
                Ownership of the physical artwork does not transfer copyright. Reproduction or commercial use is prohibited without permission.<br />
                Lastništvo fizičnega umetniškega dela ne vključuje avtorskih pravic. Reprodukcija ali komercialna uporaba brez dovoljenja je prepovedana.
            </p>
            <h2>8. GDPR AND DATA PROTECTION / GDPR IN VARSTVO PODATKOV</h2>
            <p className="mb-6">
                eduardbelskiy.com processes personal data as per GDPR. Data is used solely to process orders. Contact: info@eduardbelsky.com.<br />
                eduardbelskiy.com obdeluje osebne podatke v skladu z GDPR. Podatki se uporabljajo izključno za obdelavo naročil. Kontakt: info@eduardbelsky.com.
            </p>
            <h2>9. FORCE MAJEURE / VIŠJA SILA</h2>
            <p className="mb-6">
                The Seller is not liable for failure due to events beyond control (natural disasters, strikes, etc.).<br />
                Prodajalec ne odgovarja za neizpolnitev obveznosti zaradi dogodkov izven njegovega nadzora (naravne nesreče, stavke itd.).
            </p>
            <h2>10. FINAL PROVISIONS / KONČNE DOLOČBE</h2>
            <p className="mb-6">
                The governing law is the law of Slovenia. Disputes shall be resolved amicably or before the competent court in Slovenia.<br />
                Pristojna zakonodaja je zakonodaja Republike Slovenije. Spori se rešujejo sporazumno ali pred pristojnim sodiščem v Sloveniji.
            </p>
        </div>
    )
}

export default TermsAndConditions